import { render } from "./AddSchool.vue?vue&type=template&id=90a9f93c"
import script from "./AddSchool.vue?vue&type=script&lang=js"
export * from "./AddSchool.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__